// FullScreenLoader.js
import React from 'react';
const FullScreenLoader = () => (
  <div className="full-screen-loader">
    <div className="loader"></div>
  </div>
);

export default FullScreenLoader;
